module.exports = __webpack_public_path__ + "img/logo-tencent.707dba93.png";